/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiArtifactRecordingTrackFromJSON(json) {
    return StreemApiArtifactRecordingTrackFromJSONTyped(json, false);
}
export function StreemApiArtifactRecordingTrackFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bucket': !exists(json, 'bucket') ? undefined : json['bucket'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
        'userSid': !exists(json, 'user_sid') ? undefined : json['user_sid'],
        'trackType': !exists(json, 'track_type') ? undefined : json['track_type'],
        'codec': !exists(json, 'codec') ? undefined : json['codec'],
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'requestedAt': !exists(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'startedRecordingAt': !exists(json, 'started_recording_at') ? undefined : (new Date(json['started_recording_at'])),
        'finishedRecordingAt': !exists(json, 'finished_recording_at') ? undefined : (new Date(json['finished_recording_at'])),
        'startedTransferringAt': !exists(json, 'started_transferring_at') ? undefined : (new Date(json['started_transferring_at'])),
        'erroredAt': !exists(json, 'errored_at') ? undefined : (new Date(json['errored_at'])),
        'fulfilledAt': !exists(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'recordingSource': !exists(json, 'recording_source') ? undefined : json['recording_source'],
        'sourceRecordingTrackSid': !exists(json, 'source_recording_track_sid') ? undefined : json['source_recording_track_sid'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactRecordingTrackToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bucket': value.bucket,
        'filename': value.filename,
        'user_sid': value.userSid,
        'track_type': value.trackType,
        'codec': value.codec,
        'storage_url': value.storageUrl,
        'status': value.status,
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'started_recording_at': value.startedRecordingAt === undefined ? undefined : (value.startedRecordingAt.toISOString()),
        'finished_recording_at': value.finishedRecordingAt === undefined ? undefined : (value.finishedRecordingAt.toISOString()),
        'started_transferring_at': value.startedTransferringAt === undefined ? undefined : (value.startedTransferringAt.toISOString()),
        'errored_at': value.erroredAt === undefined ? undefined : (value.erroredAt.toISOString()),
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'url': value.url,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'recording_source': value.recordingSource,
        'source_recording_track_sid': value.sourceRecordingTrackSid,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactRecordingTrackStatus;
(function (StreemApiArtifactRecordingTrackStatus) {
    StreemApiArtifactRecordingTrackStatus["ERROR"] = "STATUS_ERROR";
    StreemApiArtifactRecordingTrackStatus["FINISHEDRECORDING"] = "STATUS_FINISHED_RECORDING";
    StreemApiArtifactRecordingTrackStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactRecordingTrackStatus["INVALID"] = "STATUS_INVALID";
    StreemApiArtifactRecordingTrackStatus["STARTEDRECORDING"] = "STATUS_STARTED_RECORDING";
    StreemApiArtifactRecordingTrackStatus["TRANSFERRING"] = "STATUS_TRANSFERRING";
})(StreemApiArtifactRecordingTrackStatus || (StreemApiArtifactRecordingTrackStatus = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactRecordingTrackRecordingSource;
(function (StreemApiArtifactRecordingTrackRecordingSource) {
    StreemApiArtifactRecordingTrackRecordingSource["ARAAS"] = "SOURCE_ARAAS";
    StreemApiArtifactRecordingTrackRecordingSource["CHIME"] = "SOURCE_CHIME";
    StreemApiArtifactRecordingTrackRecordingSource["EXTERNAL"] = "SOURCE_EXTERNAL";
    StreemApiArtifactRecordingTrackRecordingSource["INVALID"] = "SOURCE_INVALID";
    StreemApiArtifactRecordingTrackRecordingSource["TWILIO"] = "SOURCE_TWILIO";
})(StreemApiArtifactRecordingTrackRecordingSource || (StreemApiArtifactRecordingTrackRecordingSource = {}));
//# sourceMappingURL=StreemApiArtifactRecordingTrack.js.map